import React from 'react';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import ContractFormContainer from './ContractFormContainer';
import ContractProductsModalContainer from './ContractProductsModalContainer';

const ContractFormScene = (props) => (
  <>
    <Breadcrumb
      crumbs={[
        ...(props.location.state && props.location.state.from
          ? [{ text: props.location.state.from.text, link: props.location.state.from.pathname }]
          : []),
        {
          text: props.params.contractId ? 'Update Contract' : 'Create Contract',
        },
      ]}
    />
    <ContractFormContainer contractId={props.params.contractId} />
    <ContractProductsModalContainer />
  </>
);

export default ContractFormScene;
